var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFestiLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.1187,
    width: 50.744,
    height: 52.4937,
    transform: "rotate(45 37.1187 0)",
    fill: "#232530"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4067 8.66089C42.0678 17.3219 33.1747 26.2149 33.1747 26.2149L13.6101 45.7796L4.94908 37.1185C4.94908 37.1185 30.4427 11.6252 33.4067 8.66089Z",
    fill: "#E9F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1187 27.2202C45.7797 35.8812 38.3559 43.305 38.3559 43.305L24.7458 56.9152L16.0847 48.2541C16.0847 48.2541 34.9278 29.4113 37.1187 27.2202Z",
    fill: "#E9F5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8306 45.7798C49.4916 54.4408 40.8306 63.1018 40.8306 63.1018C40.8306 63.1018 40.8306 63.1018 40.8306 63.1018L35.8814 68.051L27.2204 59.39C27.2204 59.39 39.413 47.1976 40.8306 45.7798Z",
    fill: "#E9F5F5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFestiLogo);
export default __webpack_public_path__ + "static/media/festi-logo.0be86173a52ab8a073b568c5aeb14eff.svg";
export { ForwardRef as ReactComponent };